export default __webpack_public_path__ + "static/media/artistai-logo-black.0923cd8b.png";